import { FormattedMessage } from 'react-intl';
import { Box, CardContent, Grid, Typography } from 'components/ui';
import { CheckIcon } from 'components/uiIcons';
import {
  PricingCard,
  PricingBadge,
  PricingPrice,
  PricingPeriod,
  PricingFeatureList,
  PricingFeatureItem,
} from 'components/styles_components/pricing';
import { CardOptionTypography } from 'components/styles_components/typography';
import { DividerContainer } from 'components/styles_components/container';
import ChangePlanButton from 'components/space/button/change_plan';

const PlanShow = ({ plan, active, billingDetails }) => {
  const isFreePlan = plan.price === 0;
  const showButton = !isFreePlan || !active;
  const isButtonDisabled = !billingDetails || (!active && !plan.canSet);

  return (
    <Grid size={{ xs: 6, md: 4 }}>
      <PricingCard elevation={0} $highlighted={active}>
        {active && (
          <PricingBadge>
            <FormattedMessage id="plan.current" />
          </PricingBadge>
        )}
        <CardContent sx={{ p: 4, display: 'flex', flexDirection: 'column', height: '100%' }}>
          <CardOptionTypography>{plan.name}</CardOptionTypography>
          <DividerContainer />
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, flexWrap: 'wrap' }}>
            <PricingPrice>
              {plan.price == null ? (
                <FormattedMessage id="plan.individual.price" />
              ) : (
                <>
                  {plan.price} {plan.currency}
                </>
              )}
            </PricingPrice>
            <PricingPeriod>
              <FormattedMessage id={`plan.period.${plan.billingIntervalType}`} />
            </PricingPeriod>
          </Box>
          <PricingFeatureList>
            <PricingFeatureItem>
              <CheckIcon />
              {plan.inspectionsLimit == null ? (
                <FormattedMessage id="plan.inspections_unlimited" />
              ) : (
                <FormattedMessage
                  id="plan.inspections_limit"
                  values={{ limit: plan.inspectionsLimit }}
                />
              )}
            </PricingFeatureItem>
            <PricingFeatureItem>
              <CheckIcon />
              {plan.inspectionSubjectsLimit == null ? (
                <FormattedMessage id="plan.inspection_subjects_unlimited" />
              ) : (
                <FormattedMessage
                  id="plan.inspection_subjects_limit"
                  values={{ limit: plan.inspectionSubjectsLimit }}
                />
              )}
            </PricingFeatureItem>
            <PricingFeatureItem>
              <CheckIcon />
              {plan.placesLimit == null ? (
                <FormattedMessage id="plan.places_unlimited" />
              ) : (
                <FormattedMessage id="plan.places_limit" values={{ limit: plan.placesLimit }} />
              )}
            </PricingFeatureItem>
          </PricingFeatureList>
          {!active && !plan.canSet && (
            <Typography variant="caption" color="warning" sx={{ mt: 1, textAlign: 'center' }}>
              <FormattedMessage id="plan.limits_exceeded" />
            </Typography>
          )}
          {!billingDetails && plan.price != null && showButton && (
            <Typography variant="caption" color="warning" sx={{ mt: 1, textAlign: 'center' }}>
              <FormattedMessage id="plan.billing_details_required" />
            </Typography>
          )}
          {plan.price == null ? (
            <Box sx={{ mt: 'auto', justifyContent: 'center', display: 'flex' }}>
              <Typography variant="body2" sx={{ textAlign: 'center' }}>
                <FormattedMessage id="plan.contact_support" />
              </Typography>
            </Box>
          ) : (
            showButton && (
              <Box sx={{ mt: 'auto', justifyContent: 'center', display: 'flex' }}>
                <ChangePlanButton plan={plan} disabled={isButtonDisabled} active={active} />
              </Box>
            )
          )}
        </CardContent>
      </PricingCard>
    </Grid>
  );
};

export default PlanShow;
